import '@elba-security/ui-components/globals.css';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { ConsentReturn } from './ConsentReturn';
import '../style.css';

const rootElement: HTMLElement | null = document.getElementById('container');
const root = rootElement ? createRoot(rootElement) : undefined;

/* Render application after Office initializes */
const consentReturn = new URLSearchParams(window.location.search);
if (consentReturn.has('admin_consent') || consentReturn.has('error')) {
  root?.render(<ConsentReturn failed={consentReturn.has('error')} language={navigator.language} />);
} else {
  Office.onReady(() => {
    root?.render(
      <FluentProvider theme={webLightTheme}>
        <App />
      </FluentProvider>
    );
  });
}

if ((module as any).hot) {
  (module as any).hot.accept('./App', () => {
    const NextApp = require('./App').default;
    root?.render(
      <FluentProvider theme={webLightTheme}>
        <NextApp />
      </FluentProvider>
    );
  });
}
